/**
 * BrandWordmark Component
 * 
 * Consistent ThreadLock brand text logo matching the marketing site.
 * Use this component anywhere the ThreadLock brand name appears as a logo.
 * 
 * @param {boolean} darkText - If true, uses dark text (slate-800). If false, uses white text.
 * @param {string} className - Additional Tailwind classes to apply to the container.
 */

interface BrandWordmarkProps {
  darkText?: boolean;
  className?: string;
}

export default function BrandWordmark({ 
  className = "", 
  darkText = true 
}: BrandWordmarkProps) {
  return (
    <span className={`inline-flex items-baseline font-bold text-2xl tracking-tight select-none ${className}`}>
      <span className={darkText ? "text-slate-800" : "text-slate-300"}>Thread</span>
      <span className="text-orange-600">Lock</span>
      <span className={`ml-0.5 align-text-top text-[0.5em] font-black ${darkText ? 'text-slate-500' : 'text-slate-400'}`}>™</span>
    </span>
  );
}
